<template>
	<div class="pages">
		<sub-ibox-title :is-show-back = false><p slot="title">公众号管理</p></sub-ibox-title>
		<section class="list-cont">
			<ul class="fx fx-wrap">
				<router-link :to="{ name: 'wxAuth' }" tag="li">
					<span class="icon-wechet"></span>
					<p>公众号接入</p>
				</router-link>
				<router-link :to="{ name: 'wxMember' }" tag="li">
					<span class="icon-member"></span>
					<p>粉丝管理</p>
				</router-link>
				<router-link :to="{ name: 'wxMenu' }" tag="li">
					<span class="icon-wxmenu"></span>
					<p>菜单管理</p>
				</router-link>
				<router-link :to="{ name: 'wxMass'}" tag="li">
					<span class="icon-mass"></span>
					<p>群发管理</p>
				</router-link>
				<router-link :to="{ name: 'wxMaterial' }" tag="li">
					<span class="icon-material"></span>
					<p>素材管理</p>
				</router-link>
				<router-link :to="{ name: 'wxKeyWords' }" tag="li">
					<span class="icon-key"></span>
					<p>关键词管理</p>
				</router-link>
				<router-link :to="{ name: 'wxReply' }" tag="li">
					<span class="icon-reply"></span>
					<p>自动回复</p>
				</router-link>
				<!--<router-link :to="{ name: 'wxTplMsg' }" tag="li">
					<span class="icon-template"></span>
					<p>模板消息配置</p>
				</router-link>-->
				<!--<router-link :to="{ name: 'reading' }" tag="li">
					<span class="icon-dashang"></span>
					<p>打赏</p>
				</router-link>-->
			</ul>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'wxList',
		components: {
		},
		data() {
			return {
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				//				list: state => state.adminMemberPublic.list
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			handleAlert(){
				this.$messagebox('提示','此功能待开放...')
			}
		},
		deactivated() { //页面切换出去
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
			})
		}

	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.list-cont{
		background: $color-white;
		border: 1px solid $color-border;
		border-top: none;
		padding: px-em(40px);
		li {
			text-align: center;
			cursor: pointer;
			background: $color-white;
			border: 1px solid transparent;
			margin: 0 px-em(40px) px-em(40px);
			border-radius: 2px;
			position: relative;
			overflow: hidden;
			transition: all 0.25s ease;
			-webkit-transition: all 0.25s ease;
			span{
				display: inline-block;
				width: px-em(144px);
				height: px-em(144px);
				line-height: px-em(144px);
				text-align: center;
				font-size: px-em(100px) !important;
				margin: px-em(40px);
				margin-bottom: 0;
			}
			p{
				padding: px-em(20px) 0;
			}
			&:hover{
				border-color: $color-main;
			}
			&:active{
				border-color: $color-main;
				background: rgba(0,0,0,0.05);
			}
			/*定义色彩*/
			&:nth-child(1) .icon{
				color: $color-dark-green;
			}
			&:nth-child(2) .icon{
				color: $color-skyblue;
			}
			&:nth-child(3) .icon{
				color: $color-skyblue;
			}
			&:nth-child(4) .icon{
				color: $color-skyblue;
			}
			&:nth-child(5) .icon{
				color: $color-skyblue;
			}
			&:nth-child(6) .icon{
				color: $color-skyblue;
			}
			&:nth-child(7) .icon{
				color: $color-skyblue;
			}
			&:nth-child(8) .icon{
				color: $color-skyblue;
			}
			&:nth-child(9) .icon{
				color: $color-red;
			}
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.list-cont{
			padding: px-em(20px);
			ul li{
				width: 50%;
				margin: 0;
				padding-bottom: px-em(40px);
			}
		}	
	}
</style>


// WEBPACK FOOTER //
// Index.vue?492c7b42